import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import type { AdCampaignAdModel, AdCampaignModel } from '@models/types'
import type { AppDispatch } from '@redux/store'
import type {
  Action, Errors, FetchRequestPayload, RootReducerState,
} from '@redux/modules/types'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/adCampaignAd/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/adCampaignAd/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/adCampaignAd/FETCH_FAILURE'

export type AdCampaignAdModuleState = {
  errors: string[],
  loaded: boolean,
  loadedForKeys: string[],
  loading: boolean,
}

// Initial State
const initialState: AdCampaignAdModuleState = {
  errors: [],
  loaded: false,
  loadedForKeys: [],
  loading: false,
}

// Actions
export function fetchRequest(payload: FetchRequestPayload = {}) {
  return {
    type: FETCH_REQUEST,
    loadedForKeys: payload.loadedForKeys,
  }
}

export function fetchSuccess() {
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors: Errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadAdCampaignAds(adCampaign: AdCampaignModel) {
  const { adCampaignId, adChannelTypeId } = adCampaign

  return (dispatch: AppDispatch) => {
    dispatch(fetchRequest())

    const promise = api(`/ad-campaigns/${adChannelTypeId}/${adCampaignId}/ads`)
      .then(({ data }: { data: AdCampaignAdModel }) => {
        const normalizedJson = normalize(data, Schemas.AD_CAMPAIGN_AD_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true as const, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false as const, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(
  state: AdCampaignAdModuleState = initialState,
  action: Action = { type: '' },
): AdCampaignAdModuleState {
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loadedForKeys: action.loadedForKeys || state.loadedForKeys,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors || [],
      }
    default:
      return state
  }
}
